var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',[(_vm.isAdmin())?_c('b-tab',{staticClass:"tab-margin",attrs:{"title":"チャット"}},[_c('chat-main')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }